// getLiveStreamChats.js
'use strict';
import { LIVESTREAM_CHAT_LIST_LIMITATION } from '../RemoteConfigKeys.js';

import createCachedSelector from '../resource/createCachedSelector.js';
import { EMPTY_ARRAY } from '../resource/defaults.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';

/**
 * Get livestream chat ids by stream id.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {array} The selected live stream chat.
 */
const getLiveStreamChats = createCachedSelector(
  (state, streamId) =>
    getListData(state, ['liveStream', streamId, 'chat'], 'itemIds'),
  state => getRemoteConfigData(state, LIVESTREAM_CHAT_LIST_LIMITATION),
  (chatIds = EMPTY_ARRAY, max) => {
    return chatIds.slice(-max || 0);
  }
)((state, streamId) => `${streamId}`);

export default getLiveStreamChats;
